<template>
  <v-dialog
    v-model="show"
    max-width="640"
    @click:outside="close"
    data-test-id="walletTransactionDetailDialog"
  >
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon left>mdi-swap-horizontal</v-icon>
        Transaction Detail
        <v-spacer />
        <v-btn icon @click="close" data-test-id="walletTransactionDetailCloseBtn">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider />

      <v-card-text class="pt-4">
        <div v-if="loading" class="d-flex justify-center align-center py-8">
          <v-progress-circular indeterminate color="primary" />
        </div>

        <v-simple-table v-else-if="transaction" dense>
          <tbody>
            <tr v-for="(value, key) in transaction" :key="key">
              <td class="font-weight-bold" style="width: 40%">{{ key }}</td>
              <td style="word-break: break-all">{{ value }}</td>
            </tr>
          </tbody>
        </v-simple-table>

        <div v-else class="grey--text text-center py-4">
          No transaction data found.
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close" data-test-id="walletTransactionDetailDoneBtn">
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "WalletTransactionDetail",

  props: {
    transactionId: {
      type: String,
      required: true,
    },
    domain: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      show: true,
      transaction: null,
      loading: false,
    };
  },

  async created() {
    await this.loadTransaction();
  },

  methods: {
    async loadTransaction() {
      this.loading = true;
      try {
        const data = await this.$store.$coreApi.coreWalletApi.getTransaction(
          this.domain,
          this.transactionId
        );
        if (!data) return;
        this.transaction = data;
      } finally {
        this.loading = false;
      }
    },

    close() {
      this.show = false;
      this.$emit("close");
    },
  },
};
</script>
